import { Outlet } from 'react-router-dom';
import './styles';
import Header from '@/components/Header';
import classes from './style.module.css';

const DefaultLayout = () => (
  <div className={classes.layout}>
    <Header />
    <main>
      <Outlet />
    </main>
  </div>
);

export default DefaultLayout;
